import { NavLink } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import SmallBar from './smalbar';
export default function Header() {
	const { t } = useTranslation();
	const [menu, setMenu] = useState(false);
	const [scroll, setScroll] = useState(false);
	const [loginCheck, setLoginCheck] = useState(false);
	const [menuVisible, setMenuVisible] = useState(false);
	const [isAdmin, setIsAdmin] = useState(false);

	const HandleMenu = () => {
		setMenu(!menu);
	};

	useEffect(() => {
		const handleScroll = () => {
			if (window.scrollY >= 200) {
				setScroll(true);
			} else {
				setScroll(false);
			}
		};

		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	const location = useLocation();

	useEffect(() => {
		setMenu(false);
		setMenuVisible(false);
		window.scrollTo(0, 0);
	}, [location]);

	const token = Cookies.get('token');
	useEffect(() => {
		setLoginCheck(!!token);
	}, [token]);

	const userData = JSON.parse(localStorage.getItem('userData'));

	useEffect(() => {
		setIsAdmin(userData?.role?.name === 'Admin');
	}, [userData]);
	const [open, setOpen] = useState(false);
	const [openedu, setOpenedu] = useState(false);

	return (
		<header
			className={`fixed w-full top-0 left-0 z-[500] bg-${
				scroll || location.pathname === '/courses' ? 'white' : 'section'
			}`}>
			<SmallBar />
			<div className='container  mt-10 flex items-center justify-between flex-wrap xl:flex-nowrap w-[90%] border-b-[1px] border-main'>
				<div className='headerContainer flex items-center xl:w-auto'>
					<NavLink
						onClick={() => {
							setOpenedu(false);
							setOpen(false);
						}}
						to='/'>
						<div className='image w-14 my-2'>
							<img
								loading='lazy'
								src={'/logos/blue-logo.png'}
								alt='Company logo'
								className='object-cover'
							/>
						</div>
					</NavLink>
				</div>

				<div
					className={`text-secondary text-2xl font-semibold xl:hidden cursor-pointer`}
					onClick={HandleMenu}>
					☰
				</div>
				<div
					className={`w-full ${
						menu ? 'block h-[100vh]' : 'hidden'
					} xl:w-auto xl:block`}>
					<nav className='bg-white xl:bg-inherit p-4 xl:flex'>
						<ul className='xl:flex'>
							<NavLink
								onClick={() => {
									setOpenedu(false);
									setOpen(false);
								}}
								to='/'
								className={({ isActive }) =>
									`xl:gap-2 font-semibold py-2 xl:px-4 flex justify-between border-b-[1px] xl:border-b-0 border-b-blue border-b-solid transition-all duration-250 ${
										isActive
											? 'text-secondary'
											: 'text-main xl:hover:text-secondary'
									}`
								}>
								<span>{t('home')}</span>
							</NavLink>

							<div className='relative'>
								{/* زرار التوجّل */}
								<button
									onClick={() => {
										setOpenedu(!openedu);
										setOpen(false);
									}}
									className='px-4 py-2 font-semibold text-gray-800 rounded-lg focus:outline-none'>
									{openedu ? t('ta3lem') : t('ta3lem')}
								</button>

								{openedu && (
									<div className='absolute mt-2 w-60 bg-white shadow-lg rounded-lg overflow-hidden border border-gray-200 z-50'>
										<NavLink
											onClick={() => {
												setOpenedu(false);
												setOpen(false);
											}}
											to='/article'
											className={({ isActive }) =>
												`xl:gap-2 font-semibold py-2 xl:px-4 flex justify-between border-b border-gray-200 border-b-blue border-b-solid transition-all duration-250 ${
													isActive
														? 'text-secondary'
														: 'text-main xl:hover:text-secondary'
												}`
											}>
											<span>{t('article')}</span>
										</NavLink>
										<NavLink
											onClick={() => {
												setOpenedu(false);
												setOpen(false);
											}}
											to='/projects'
											className={({ isActive }) =>
												`xl:gap-2 font-semibold py-2 xl:px-4 flex justify-between border-b border-gray-200 border-b-blue border-b-solid transition-all duration-250 ${
													isActive
														? 'text-secondary'
														: 'text-main xl:hover:text-secondary'
												}`
											}>
											<span>{t('Projects')}</span>
										</NavLink>
										<NavLink
											onClick={() => {
												setOpenedu(false);
												setOpen(false);
											}}
											to='/roadMap'
											className={({ isActive }) =>
												`xl:gap-2 font-semibold py-2 xl:px-4 flex justify-between   border-b border-gray-200 border-b-blue border-b-solid transition-all duration-250 ${
													isActive
														? 'text-secondary'
														: 'text-main xl:hover:text-secondary'
												}`
											}>
											<span>{t('roadMap')}</span>
										</NavLink>
									</div>
								)}
							</div>
							<div className='relative'>
								{/* زرار التوجّل */}
								<button
									onClick={() => {
										setOpen(!open);
										setOpenedu(false);
									}}
									className='px-4 py-2 font-semibold text-gray-800 rounded-lg focus:outline-none'>
									{open ? t('mogtama3') : t('mogtama3')}
								</button>

								{open && (
									<div className='absolute mt-2 w-60 bg-white shadow-lg rounded-lg overflow-hidden border border-gray-200 z-50'>
										<NavLink
											to='/active'
											onClick={() => {
												setOpenedu(false);
												setOpen(false);
											}}
											className={({ isActive }) =>
												`block font-semibold py-2 px-4 border-b border-gray-200 transition-all duration-200 ${
													isActive
														? 'text-blue-600 bg-gray-100'
														: 'text-gray-800 hover:text-blue-600'
												}`
											}>
											{t('active')}
										</NavLink>

										<NavLink
											to='/users'
											onClick={() => {
												setOpenedu(false);
												setOpen(false);
											}}
											className={({ isActive }) =>
												`block font-semibold py-2 px-4 border-b border-gray-200 transition-all duration-200 ${
													isActive
														? 'text-blue-600 bg-gray-100'
														: 'text-gray-800 hover:text-blue-600'
												}`
											}>
											{t('users')}
										</NavLink>

										<NavLink
											to='/InstructorsPage'
											onClick={() => {
												setOpenedu(false);
												setOpen(false);
											}}
											className={({ isActive }) =>
												`block font-semibold py-2 px-4 border-b border-gray-200  transition-all duration-200 ${
													isActive
														? 'text-blue-600 bg-gray-100'
														: 'text-gray-800 hover:text-blue-600'
												}`
											}>
											{t('Instructors')}
										</NavLink>
										<NavLink
											to='/Terms'
											onClick={() => {
												setOpenedu(false);
												setOpen(false);
											}}
											className={({ isActive }) =>
												`block font-semibold py-2 px-4 transition-all duration-200 ${
													isActive
														? 'text-blue-600 bg-gray-100'
														: 'text-gray-800 hover:text-blue-600'
												}`
											}>
											{t('terms')}
										</NavLink>
									</div>
								)}
							</div>

							{!loginCheck && (
								<NavLink
									onClick={() => {
										setOpenedu(false);
										setOpen(false);
									}}
									to='/courses'
									className={({ isActive }) =>
										`xl:gap-2 font-semibold py-2 xl:px-4 flex justify-between border-b-[1px] xl:border-b-0 border-b-blue border-b-solid transition-all duration-250 ${
											isActive
												? 'text-secondary'
												: 'text-main xl:hover:text-secondary'
										}`
									}>
									<span>{t('courses')}</span>
								</NavLink>
							)}
							<NavLink
								onClick={() => {
									setOpenedu(false);
									setOpen(false);
								}}
								to='/Contact'
								className={({ isActive }) =>
									`xl:gap-2 font-semibold py-2 xl:px-4 flex justify-between border-b-[1px] xl:border-b-0 border-b-blue border-b-solid transition-all duration-250 ${
										isActive
											? 'text-secondary'
											: 'text-main xl:hover:text-secondary'
									}`
								}>
								<span>{t('subscribeNow')}</span>
							</NavLink>

							{loginCheck && (
								<>
									{isAdmin && (
										<NavLink
											onClick={() => {
												setOpenedu(false);
												setOpen(false);
											}}
											to='/admin'
											className={({ isActive }) =>
												`xl:gap-2 font-semibold py-2 xl:px-4 flex justify-between border-b-[1px] xl:border-b-0 border-b-blue border-b-solid transition-all duration-250 ${
													isActive
														? 'text-secondary'
														: 'text-main xl:hover:text-secondary'
												}`
											}>
											<span>{t('admin')}</span>
										</NavLink>
									)}
								</>
							)}

							{menu && !loginCheck && (
								<>
									<NavLink
										onClick={() => {
											setOpenedu(false);
											setOpen(false);
										}}
										to='/login'
										className='xl:gap-2 text-main font-semibold py-2 xl:px-4 flex justify-between border-b-[1px] xl:border-b-0 border-b-blue border-b-solid '>
										<span>{t('Login')}</span>
									</NavLink>
									<NavLink
										onClick={() => {
											setOpenedu(false);
											setOpen(false);
										}}
										to='/signup'
										className='xl:gap-2 text-main font-semibold py-2 xl:px-4  flex justify-between border-b-[1px] xl:border-b-0 border-b-blue border-b-solid'>
										<span>{t('Sign Up')}</span>
									</NavLink>
								</>
							)}
						</ul>
					</nav>
				</div>
				{loginCheck ? (
					<div className='w-full xl:w-auto relative bg-white xl:bg-inherit rounded-md'>
						<div
							className='forms hidden xl:flex mt-0 w-12 h-12 rounded-full justify-center items-center text-white bg-main cursor-pointer'
							onClick={() => setMenuVisible(!menuVisible)}>
							<div className='text-center'>
								{`${userData.firstName
									.slice(0, 1)
									.toUpperCase()}${userData.lastName
									.slice(0, 1)
									.toUpperCase()}`}
							</div>
						</div>

						{menuVisible && (
							<div className='absolute top-full right-0 mt-2 w-48 bg-white p-2 rounded-lg shadow-lg z-50 hidden xl:block'>
								<ul className='flex flex-col gap-2 text-main'>
									<NavLink
										onClick={() => {
											setOpenedu(false);
											setOpen(false);
										}}
										to='/profile'
										className={({ isActive }) =>
											`block p-2 rounded ${
												isActive
													? 'text-white bg-main'
													: 'xl:hover:text-white xl:hover:bg-main'
											}`
										}>
										Profile
									</NavLink>
									{!isAdmin && (
										<>
											<NavLink
												onClick={() => {
													setOpenedu(false);
													setOpen(false);
												}}
												to='/my-learning'
												className={({ isActive }) =>
													`block p-2 rounded ${
														isActive
															? 'text-white bg-main'
															: 'xl:hover:text-white xl:hover:bg-main'
													}`
												}>
												My Learning
											</NavLink>
										</>
									)}
								</ul>
							</div>
						)}

						<div className='xl:hidden flex justify-evenly xl:justify-center gap-4 rounded-md bg-white text-center text-sm'>
							<NavLink
								onClick={() => {
									setOpenedu(false);
									setOpen(false);
								}}
								to='/'
								className={({ isActive }) =>
									`block p-2 rounded grow text-center ${
										isActive
											? 'text-white bg-main'
											: 'xl:hover:text-white xl:hover:bg-main'
									}`
								}>
								{t('home')}
							</NavLink>
							{!isAdmin && (
								<>
									<NavLink
										onClick={() => {
											setOpenedu(false);
											setOpen(false);
										}}
										to='/my-learning/'
										className={({ isActive }) =>
											`block p-2 rounded grow text-center ${
												isActive
													? 'text-white bg-main'
													: 'xl:hover:text-white xl:hover:bg-main'
											}`
										}>
										My Learning
									</NavLink>
									<NavLink
										onClick={() => {
											setOpenedu(false);
											setOpen(false);
										}}
										to='/courses'
										className={({ isActive }) =>
											`xl:gap-2 font-semibold py-2 xl:px-4 flex justify-between border-b-[1px] xl:border-b-0 border-b-blue border-b-solid transition-all duration-250 ${
												isActive
													? 'text-secondary'
													: 'text-main xl:hover:text-secondary'
											}`
										}>
										<span>{t('courses')}</span>
									</NavLink>
								</>
							)}
						</div>
					</div>
				) : (
					<div className='forms hidden xl:flex gap-2'>
						<button className='py-2 px-5 text-main'>
							<NavLink
								onClick={() => {
									setOpenedu(false);
									setOpen(false);
								}}
								to='/login'>
								{t('Login')}
							</NavLink>
						</button>
						<button className='py-2 px-5 text-main text-white bg-secondary rounded'>
							<NavLink
								onClick={() => {
									setOpenedu(false);
									setOpen(false);
								}}
								to='/signup'>
								{t('Sign Up')}
							</NavLink>
						</button>
					</div>
				)}
			</div>
		</header>
	);
}
